module.exports = __webpack_public_path__ + "static/media/service-3.52cf19fd.jpg";